<template>
  <div>
    <v-overlay :value="isBusy">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-card-text>
      <div class="d-flex my-auto">
        <div class="text-body-1 my-auto mr-2">Indexed At Grading</div>
        <v-spacer />
        <div class="mr-2 text-body-1 my-auto ">v{{ appVersion }}</div>
        <v-spacer />
        <img 
          class="mt-1" 
          src="@/assets/img/cobb-logo.png" 
          alt="Cobb Logo"
          height="38"
        />
      </div>

      <v-divider class="mt-4 mb-2" />

      <div class="mb-3 d-flex my-auto">
        <div :class="`mt-2 mr-1 text-${breakpoint === 'xs' ? 'subtitle-1' : 'h6'} text-truncate`">
          User: {{ userName }}
        </div>
        <v-spacer />
        <v-btn
          color="primary"
          class="mt-1 mr-3 white--text"
          @click="reloadApp()"
          :disabled="!isOnline">
          <v-icon class="mr-1">mdi-reload</v-icon>
          Reload
        </v-btn>

        <v-btn
          v-if="userName != null"
          class="mt-1 px-2 pr-3"
          color="secondary"
          :disabled="!isOnline"
          @click="signOut()"
        >
           <v-icon class="mr-1">mdi-exit-run</v-icon>
          Sign Out
        </v-btn>
      </div>

      <v-divider class="mb-4" />

      <div class="text-subtitle-1">Display:</div>
      <div class="d-flex flex-wrap">
        <v-switch 
          v-model="darkMode"
          inset
          class="pa-0 mt-1 ml-2 mr-2"
          label="Dark Mode"
        />
      </div>

      <v-divider class="mt-0 mb-4" />

      <div>
        <div class="ml-2 text-subtitle-1 text-no-wrap">Api Url:</div>
        <div style="word-break: break-word" class="text-subtitle-2  text-truncate ml-5 mt-1">{{ apiUrl }}</div>
      </div>

      <v-divider class="my-4" />
    </v-card-text>
  </div>
</template>
<script>
import { version as appVersion } from '../../package.json'
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      appVersion: appVersion,
      isBusy: false,
    }
  },
  async created() {
  },
  computed: {
    ...mapState(['settings', 'isOnline', 'userProfile']),
    apiUrl() {
      return process.env.VUE_APP_ROOT_API_SERVER_URL;
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    darkMode: {
      get() { return this.settings.isDarkMode === true; },
      set(value) {
        const settings = { ...this.settings };
        settings.isDarkMode = value;
        this.updateSettingsInStore(settings);
        this.$vuetify.theme.dark = value;
        window.dispatchEvent(new CustomEvent('iag-set-scrollbar-theme'));
      }
    },
    userName() {
      if (this.userProfile) {
        var userName = this.userProfile.displayName;
        return userName;
      }
      else return null;
    }
  },
  methods: {
    ...mapActions(['updateSettingsInStore', 'storeSignOut']),
    async signOut() {
      await this.storeSignOut();
    },
    reloadApp() {
      window.location = process.env.BASE_URL;
    }
  }
}
</script>